import React from "react";
import { Box } from "theme-ui";

interface TableWrapperProps {
  children: React.ReactNode;
}

function TableWrapper(props: TableWrapperProps) {
  return (
    <Box
      {...props}
      sx={{
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0 5px 10px rgb(0 0 0 / 15%)",
        marginTop: "10px",
        padding: "10px",
      }}
    />
  );
}

export default TableWrapper;
